// press-page.js
const pressItems = [
  {
    category: "Digital Media",
    title: "Sock Guys - John's Crazy Socks Documentary",
    outlet: "Vimeo",
    date: "2024",
    link: "https://player.vimeo.com/video/489552247",
    image: "https://cdn.shopify.com/s/files/1/1631/8771/files/Sock-Guys-DOCUMENTARY-SHORT-on-Vimeo-01-13-2025_01_18_PM.png?v=1736792383", // You may want to replace with a video thumbnail
    type: "vimeo"
  },
  {
    category: "Television",
    title: "John's Crazy Socks and the Catholic Faith Network",
    outlet: "Catholic Faith Network",
    date: "2023",
    link: "https://www.youtube.com/watch?v=tgXUzb7Zmug",
    image: "https://cdn.shopify.com/s/files/1/1631/8771/files/catholic.png?v=1736788195", // You may want to replace with CFN logo
    type: "youtube"
  },
  {
    category: "Television",
    title: "Newsmax Down Syndrome Day Coverage",
    outlet: "Newsmax",
    date: "2023",
    link: "https://www.youtube.com/watch?v=Y_voMk1JMtQ",
    image: "https://cdn.shopify.com/s/files/1/1631/8771/files/newsmax.png?v=1736788262", // You may want to replace with Newsmax logo
    type: "youtube"
  },
  {
    category: "Television",
    title: "WNDU Channel 16 Feature",
    outlet: "WNDU",
    date: "2023",
    link: "https://www.youtube.com/watch?v=LlGj0gIJ4I4",
    image: "https://cdn.shopify.com/s/files/1/1631/8771/files/16_now.png?v=1736788291", // You may want to replace with WNDU logo
    type: "youtube"
  },
  {
    category: "Television",
    title: "Feature",
    outlet: "WNDU",
    date: "2023",
    link: "https://www.youtube.com/watch?v=rQKhIB1TB7U",
    image: "https://cdn.shopify.com/s/files/1/1631/8771/files/16_now_2.png?v=1736788415",
    type: "youtube"
  },
  {
    category: "Television",
    title: "The story behind the socks Bush 41 wore to Barbara's funeral",
    outlet: "News Feature",
    date: "2023",
    link: "https://www.youtube.com/watch?v=hMl7E6Iz7tA",
    image: "https://cdn.shopify.com/s/files/1/1631/8771/files/fox_41.png?v=1736788363", // You may want to replace with appropriate logo
    type: "youtube"
  },
  {
    category: "Television",
    title: "ABC News 7 Washington DC - Businesses Urged To Hire More People With Disabilities",
    outlet: "ABC News",
    date: "October 2021",
    link: "https://cdn.shopify.com/s/files/1/1631/8771/files/WJLA_10-26-2021_wash_DC_channel_7.mp4?v=1635512459",
    image: "https://cdn.shopify.com/s/files/1/1631/8771/files/mark_and_john_capital_hill.png?v=1635512415",
    type: "video"
  },
  {
    category: "Television",
    title: "Socks unite Congress members from both sides of the aisle",
    outlet: "Local DVM",
    date: "October 2021",
    link: "https://www.localdvm.com/news/washington-dc/socks-unite-congress-members-from-both-sides-of-the-aisle/",
    image: "https://cdn.shopify.com/s/files/1/1631/8771/files/john_and_mark_capital_hill_DC.png?v=1635511345",
    type: "article"
  },
  {
    category: "Television",
    title: "KTBC Fox 7 Austin raising awareness about abilities of people with disabilities",
    outlet: "Fox 7",
    date: "October 2021",
    link: "https://cdn.shopify.com/s/files/1/1631/8771/files/KTBC_Fox_7_Austin_-10-25-21_-_Raising_Awareness_About_Abilities_of_People_with_Disabilities.mp4?v=1635452704",
    image: "https://cdn.shopify.com/s/files/1/1631/8771/files/fox_7_austin_johns_crazy_socks.png?v=1635452508",
    type: "video"
  },
  {
    category: "Television",
    title: "Father-son team creating opportunities for those with different abilities",
    outlet: "WSAW",
    date: "October 2021",
    link: "https://www.wsaw.com/2021/10/14/father-son-team-creating-opportunities-those-with-different-abilities/",
    image: "https://cdn.shopify.com/s/files/1/1631/8771/files/Father-son-team-creating-opportunities-for-those-with-different-abilities.png?v=1634303797",
    type: "article"
  },
  {
    category: "Television",
    title: "New York entrepreneur with Down Syndrome wants to unite Congress through socks",
    outlet: "Fox News",
    date: "February 2021",
    link: "https://www.foxnews.com/politics/new-york-entrepreneur-with-down-syndrome-wants-to-unite-congress-through-socks",
    image: "https://cdn.shopify.com/s/files/1/1631/8771/files/Fox-News-logo-removebg-preview.png?v=1614369312",
    type: "article"
  },
  {
    category: "Television",
    title: "WNBC 4 Covers John's Crazy Socks Special Donation at Long Island Hospital",
    outlet: "WNBC",
    date: "February 2021",
    link: "https://www.youtube.com/watch?v=sSu8Rpe7cU0",
    image: "https://cdn.shopify.com/s/files/1/1631/8771/files/350-WNBC_4_NY.png?v=1617204124",
    type: "youtube"
  },
  {
    category: "Television",
    title: "Sock business is booming for man with Down syndrome",
    outlet: "ABC News",
    date: "May 2017",
    link: "https://abcnews.go.com/Lifestyle/man-syndromes-sock-business-booming/story?id=47166223",
    image: "https://cdn.shopify.com/s/files/1/1631/8771/files/abc_news.png?v=1614358646",
    type: "article"
  },
  {
    category: "Television",
    title: "Father and son spread happiness, one crazy pair of socks at a time",
    outlet: "CBS News",
    date: "June 2018",
    link: "https://www.cbsnews.com/news/johns-crazy-socks-father-and-son-spread-happiness-one-crazy-pair-of-socks-at-a-time/",
    image: "https://cdn.shopify.com/s/files/1/1631/8771/files/cbs1.png?v=1614358647",
    type: "article"
  },
  {
    category: "Awards",
    title: "John's Crazy Socks co-founder becomes 1st person with Down syndrome to win major entrepreneurs' award",
    outlet: "Fox News",
    date: "June 2019",
    link: "https://www.foxnews.com/health/johns-crazy-socks-co-founder-down-syndrome-entrepreneur-award",
    image: "https://cdn.shopify.com/s/files/1/1631/8771/files/Fox-News-logo-removebg-preview.png?v=1614369312",
    type: "article"
  },
  {
    category: "Digital Media",
    title: "How this entrepreneur with Down syndrome built a multimillion-dollar business",
    outlet: "CNBC",
    date: "October 2018",
    link: "https://www.youtube.com/watch?v=WU-T7P4QG6Y",
    image: "https://cdn.shopify.com/s/files/1/1631/8771/files/cnbc.png?v=1614358802",
    type: "youtube"
  },
  {
    category: "Television",
    title: "John talking about his connection to former President George H.W. Bush",
    outlet: "Fox News",
    date: "December 2018",
    link: "https://video.foxnews.com/v/5976088055001#sp=show-clips",
    image: "https://cdn.shopify.com/s/files/1/1631/8771/files/foxmartha_f4b92e72-9bab-441f-be5a-a745851be618.png?v=1614362648",
    type: "video"
  },
  {
    category: "Television",
    title: "John and Mark visiting Fox & Friends",
    outlet: "Fox News",
    date: "November 2017",
    link: "https://www.youtube.com/watch?v=2ujCli1U7gs",
    image: "https://cdn.shopify.com/s/files/1/1631/8771/files/foxfriends_d1694b79-9de8-453e-80df-476133e6b4c1.png?v=1614360438",
    type: "youtube"
  },
  {
    category: "International",
    title: "John's Crazy Socks feature on BBC",
    outlet: "BBC",
    date: "January 2018",
    link: "https://www.bbc.com/news/av/business-42652222",
    image: "https://cdn.shopify.com/s/files/1/1631/8771/files/bbc.png?v=1614358749",
    type: "video"
  },
  {
    category: "Television",
    title: "Interview with Steve Adubato on PBS",
    outlet: "PBS",
    date: "June 2018",
    link: "https://www.pbs.org/video/spreading-happiness-johns-crazy-socks-rupu4u/",
    image: "https://cdn.shopify.com/s/files/1/1631/8771/files/PBS_logo.png.crdownload?v=1614643384",
    type: "video"
  },
  {
    category: "Digital Media",
    title: "Google's Feature on John's Crazy Socks",
    outlet: "Google",
    date: "June 2018",
    link: "https://www.youtube.com/watch?v=rYMgpmbhkgk",
    image: "https://cdn.shopify.com/s/files/1/1631/8771/files/google-square-removebg-preview.png?v=1614369059",
    type: "youtube"
  },
  {
    category: "Digital Media",
    title: "Microsoft on how John's Crazy Socks shows what people with disabilities can achieve",
    outlet: "Microsoft",
    date: "October 2018",
    link: "https://www.youtube.com/watch?v=q-hLvRiEINc",
    image: "https://cdn.shopify.com/s/files/1/1631/8771/files/micro_s.png?v=1614362729",
    type: "youtube"
  },
  {
    category: "Digital Media",
    title: "John's Crazy Socks Owners Testify Before Congress",
    outlet: "Yahoo Finance",
    date: "May 2018",
    link: "https://finance.yahoo.com/news/john-crazy-socks-owners-testify-184717769.html",
    image: "https://cdn.shopify.com/s/files/1/1631/8771/files/yahoo.png?v=1614363693",
    type: "article"
  },
  {
    category: "Digital Media",
    title: "Man with Down syndrome starts million-dollar sock company",
    outlet: "Today Show",
    date: "January 2018",
    link: "https://www.today.com/parents/man-down-syndrome-starts-million-dollar-sock-company-t121592",
    image: "https://cdn.shopify.com/s/files/1/1631/8771/files/today-show-removebg-preview.png?v=1614369510",
    type: "article"
  },
  {
    category: "Print Media",
    title: "List of 11 Best No-Show Socks for Men and Women",
    outlet: "Good Housekeeping",
    date: "December 2020",
    link: "https://www.goodhousekeeping.com/clothing/g27243937/no-show-socks/",
    image: "https://cdn.shopify.com/s/files/1/1631/8771/files/good_house.png?v=1614358646",
    type: "article"
  },
  {
    category: "International",
    title: "Man with Down syndrome owns multi-million-dollar sock business",
    outlet: "CTV News",
    date: "April 2018",
    link: "https://www.ctvnews.ca/lifestyle/man-with-down-syndrome-owns-multi-million-dollar-sock-business-1.3883425",
    image: "https://cdn.shopify.com/s/files/1/1631/8771/files/ctv.png?v=1614358646",
    type: "article"
  },
  {
    category: "Print Media",
    title: "Documentary on LI father and son to be featured at online Reel Abilities Film Festival",
    outlet: "New York Post",
    date: "April 2020",
    link: "https://nypost.com/video/founder-of-million-dollar-sock-company-has-special-needs/",
    image: "https://cdn.shopify.com/s/files/1/1631/8771/files/ny_post.png?v=1614363059",
    type: "video"
  }
];

const categories = {
  'Television': ['ABC', 'CBS', 'Fox', 'NBC', 'PBS'],
  'Print Media': ['New York Post', 'Good Housekeeping', "Woman's Day"],
  'Digital Media': ['CNBC', 'Yahoo', 'The Mighty', 'Google', 'Microsoft'],
  'International': ['BBC', 'CTV News'],
  'Awards': ['EY Entrepreneur Award']
};

function renderCategories() {
  const categoriesEl = document.getElementById('categories');
  let html = `<button class="category-btn active" data-category="All">All Coverage</button>`;
  
  Object.keys(categories).forEach(category => {
    html += `<button class="category-btn" data-category="${category}">${category}</button>`;
  });
  
  categoriesEl.innerHTML = html;
}

function renderPressItems(category = 'All') {
  const gridEl = document.getElementById('press-grid');
  const items = category === 'All' ? pressItems : pressItems.filter(item => item.category === category);
  
  const html = items.map(item => `
    <div class="press-card">
      <div class="press-image-container">
        <img src="${item.image}" alt="${item.title}" class="press-image">
        ${(item.type === 'youtube' || item.type === 'video' || item.type === 'vimeo') ? `
          <div class="play-button-overlay">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="white">
              <path d="M8 5v14l11-7z"/>
            </svg>
          </div>
        ` : ''}
      </div>
      <div class="press-content">
        <p class="press-meta">${item.outlet} • ${item.date}</p>
        <h3 class="press-title">${item.title}</h3>
        <a href="${item.link}" target="_blank" rel="noopener noreferrer" class="press-link">
          ${(item.type === 'youtube' || item.type === 'video' || item.type === 'vimeo') ? 'Watch Video →' : 'Read More →'}
        </a>
      </div>
    </div>
  `).join('');
  
  gridEl.innerHTML = html;
}

function initPressPage() {
  renderCategories();
  renderPressItems();
  
  document.getElementById('categories').addEventListener('click', (e) => {
    if (e.target.classList.contains('category-btn')) {
      document.querySelectorAll('.category-btn').forEach(btn => btn.classList.remove('active'));
      e.target.classList.add('active');
      renderPressItems(e.target.dataset.category);
    }
  });
}

document.addEventListener('DOMContentLoaded', initPressPage);